module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/dinner-ec70d3ddc62cebb03ce0cf7c8509012e.jpeg";